import { useCallback, useEffect, useState } from "react";
import { getErrorMessage } from "utils/cms";

export default function useResourceList({ list, remove, confirm }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState("");
  const [toast, setToast] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await list();
      const data = res.data?.data || {};
      setItems(data.items || []);
      setTotal(data.total || 0);
    } catch (err) {
      if (err.response?.status === 404) {
        setItems([]);
        setTotal(0);
      } else {
        setError(getErrorMessage(err));
      }
    } finally {
      setLoading(false);
    }
  }, [list]);

  useEffect(() => {
    load();
  }, [load]);

  const onDelete = async (item) => {
    if (!window.confirm(confirm(item))) return;
    setDeletingId(item._id);
    try {
      const res = await remove(item._id);
      setToast({
        type: "success",
        message: res.data?.message || "Deleted successfully",
        id: Date.now(),
      });
      await load();
    } catch (err) {
      setToast({ type: "error", message: getErrorMessage(err), id: Date.now() });
    } finally {
      setDeletingId("");
    }
  };

  return {
    items,
    total,
    loading,
    error,
    toast,
    setToast,
    deletingId,
    onDelete,
  };
}
